export * from './FolderXIcon';
export * from './FolderXIcon16Light';
export * from './FolderXIcon16Regular';
export * from './FolderXIcon16Solid';
export * from './FolderXIcon20Light';
export * from './FolderXIcon20Regular';
export * from './FolderXIcon20Solid';
export * from './FolderXIcon24Regular';
export * from './FolderXIcon24Solid';
export * from './FolderXIcon32Regular';
export * from './FolderXIcon64Regular';
